import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.number.constructor.js";
import MyLayout from '../Layout/Layout';
import { Button } from 'element-ui';
export default {
  components: {
    MyLayout: MyLayout,
    ElButton: Button
  },
  props: {
    width: Number,
    height: Number,
    theme: String,
    title: String,
    icon: Object,
    footer: Boolean,
    submitText: {
      type: String,
      default: '确定'
    },
    submitVisible: Boolean,
    submitLoading: Boolean,
    cancelText: {
      type: String,
      default: '取消'
    },
    headerHeight: {
      type: Number,
      default: 46
    },
    footerHeight: {
      type: Number,
      default: 54
    },
    closable: {
      type: Boolean,
      default: true
    },
    beforeClose: Function,
    maximizable: Boolean,
    maximized: Boolean,
    minimizable: Boolean,
    minimized: Boolean
  },
  computed: {
    styles: function styles() {
      return {
        width: this.width ? "".concat(this.width, "px") : 'auto',
        height: this.height ? "".concat(this.height, "px") : 'auto'
      };
    },
    classes: function classes() {
      return _defineProperty(_defineProperty({}, "is-".concat(this.theme), !!this.theme), 'is-has-height', !!this.width);
    }
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.$emit('submit');
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    handleClose: function handleClose() {
      var _this = this;
      if (this.beforeClose) {
        this.beforeClose().then(function (r) {
          _this.$emit('close');
        });
      } else {
        this.$emit('close');
      }
    },
    handleMaximized: function handleMaximized(maximized) {
      this.$emit('update:maximized', maximized);
    },
    handleMinimized: function handleMinimized() {
      this.$emit('update:minimized', true);
    }
  }
};